import { useRecoilValueLoadable } from "recoil";
import { AllProgressCheckStatuses, ProgramData } from "@interfaces/Interfaces";
import { progressCheckDataAtom } from "@state/State";
import { useProgramData } from "@hooks/data/useProgramData";
import * as ProgramUtils from "@utils/programUtils";

type UseProgramCyclesResult = {
  currentProgramCycle: number | undefined;
  getCycleForProgram: (programID: string) => number | undefined;
};

export const useProgramCycles = (programID?: string): UseProgramCyclesResult => {
  const { userPrograms } = useProgramData();
  const program: ProgramData = userPrograms.find((item) => item.ID === programID)!;
  const allProgressCheckData = useRecoilValueLoadable<AllProgressCheckStatuses[]>(progressCheckDataAtom);

  let currentProgramCycle: number | undefined;

  if (allProgressCheckData.state === "hasValue" && ProgramUtils.programHasCycles(programID ?? "")) {
    const dataForProgram: AllProgressCheckStatuses | undefined = allProgressCheckData.contents?.find(
      (item: AllProgressCheckStatuses): item is AllProgressCheckStatuses => item.programID === programID
    );

    if (program?.ProgressChecks && dataForProgram) {
      let maxCycle = 1;

      for (const progressCheckStatus of dataForProgram.pCs) {
        if (progressCheckStatus.submissions?.cycle !== undefined) {
          const cycleNumber = progressCheckStatus.submissions.cycle!;
          if (cycleNumber > maxCycle) {
            maxCycle = cycleNumber;
          }
        }
      }

      currentProgramCycle = maxCycle;
    }
  }

  const getCycleForProgram = (programID: string): number | undefined => {
    if (allProgressCheckData.state === "hasValue" && ProgramUtils.programHasCycles(programID)) {
      const selectedProgram: ProgramData = userPrograms.find((item) => item.ID === programID)!;

      const dataForProgram: AllProgressCheckStatuses | undefined = allProgressCheckData.contents?.find(
        (item: AllProgressCheckStatuses): item is AllProgressCheckStatuses => item.programID === programID
      );

      if (selectedProgram.ProgressChecks && dataForProgram) {
        let maxCycle = 1;

        for (const progressCheckStatus of dataForProgram.pCs) {
          if (progressCheckStatus.submissions?.cycle !== undefined) {
            const cycleNumber = progressCheckStatus.submissions.cycle!;
            if (cycleNumber > maxCycle) {
              maxCycle = cycleNumber;
            }
          }
        }

        return maxCycle;
      }
    }
  };

  return {
    currentProgramCycle,
    getCycleForProgram,
  };
};
